import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormStyled } from './Form.styled';

interface Props {
  question: string;
  hint: string;
  name: string;
  value: string;
  onChange?: any;
  color?: string;
  tooltip?: any;
}

export const InputTexFieldForm = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <FormStyled.WrapperQuestionTitle>
        <FormStyled.Marker></FormStyled.Marker>
        <FormStyled.Question
          dangerouslySetInnerHTML={{
            __html: t(props.question)
          }}
        ></FormStyled.Question>
        {props.tooltip && props.tooltip}
      </FormStyled.WrapperQuestionTitle>
      <FormStyled.InputField
        style={{ borderColor: props.color }}
        value={props.value}
        onChange={props.onChange}
        name={props.name}
        placeholder={props.hint}
      />
    </div>
  );
};
